/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  establishment?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  originalAddress?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
};

export type Airport = {
  __typename?: 'Airport';
  date?: Maybe<Scalars['String']['output']>;
  iataCode?: Maybe<Scalars['String']['output']>;
  terminal?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export type AirportByIataCodeRequestParams = {
  iataCode?: InputMaybe<Scalars['String']['input']>;
};

export type AirportByIataCodeResponse = {
  __typename?: 'AirportByIATACodeResponse';
  flightDetails?: Maybe<Array<Maybe<FlightsInfo>>>;
  originHubDetails?: Maybe<AirportDetails>;
};

export type AirportDetails = {
  __typename?: 'AirportDetails';
  cityName?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  iataCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ApplicationSetting = {
  __typename?: 'ApplicationSetting';
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ApplicationSettingEntityList = {
  __typename?: 'ApplicationSettingEntityList';
  pagination?: Maybe<Pagination>;
  results?: Maybe<Array<Maybe<ApplicationSetting>>>;
};

export type ApplicationSettingsRequestParams = {
  category?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Article = {
  __typename?: 'Article';
  author_id?: Maybe<Scalars['Float']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  comments_disabled?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  draft?: Maybe<Scalars['Boolean']['output']>;
  edited_at?: Maybe<Scalars['String']['output']>;
  html_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  label_names?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locale?: Maybe<Scalars['String']['output']>;
  outdated?: Maybe<Scalars['Boolean']['output']>;
  outdated_locales?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  permission_group_id?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  promoted?: Maybe<Scalars['Boolean']['output']>;
  section?: Maybe<SectionInformation>;
  section_id?: Maybe<Scalars['Float']['output']>;
  source_locale?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user_segment_id?: Maybe<Scalars['Float']['output']>;
  vote_count?: Maybe<Scalars['Int']['output']>;
  vote_sum?: Maybe<Scalars['Float']['output']>;
};

export type ArticleEntityList = {
  __typename?: 'ArticleEntityList';
  articles?: Maybe<Array<Maybe<Article>>>;
  count?: Maybe<Scalars['Int']['output']>;
  next_page?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  page_count?: Maybe<Scalars['Int']['output']>;
  per_page?: Maybe<Scalars['Int']['output']>;
  previous_page?: Maybe<Scalars['Int']['output']>;
  sort_by?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['String']['output']>;
};

export type ArticleInformation = {
  __typename?: 'ArticleInformation';
  article?: Maybe<Article>;
};

export type Attachment = {
  __typename?: 'Attachment';
  content_type?: Maybe<Scalars['String']['output']>;
  content_url?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mapped_content_url?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AutoCompleteAddressItem = {
  __typename?: 'AutoCompleteAddressItem';
  formattedAddress: Scalars['String']['output'];
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  hereId?: Maybe<Scalars['String']['output']>;
  hubId?: Maybe<Scalars['Int']['output']>;
  matchedSubstrings?: Maybe<Array<Maybe<MatchedSubstring>>>;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum AutoCompleteAddressMode {
  Cascade = 'CASCADE',
  Full = 'FULL'
}

export type AutoCompleteAddressesParams = {
  language?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<AutoCompleteAddressMode>;
  size?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};

export type BookerInfo = {
  __typename?: 'BookerInfo';
  companyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  languageIsoCode?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  receiveJourneyUpdates?: Maybe<Scalars['Boolean']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  traveller?: Maybe<Scalars['Boolean']['output']>;
};

export type BookerInfoParams = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  languageIsoCode?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receiveJourneyUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  traveller?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Booking = {
  __typename?: 'Booking';
  bookerInfo?: Maybe<BookerInfo>;
  code?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  journeyCount?: Maybe<Scalars['Int']['output']>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  partnerReference?: Maybe<Scalars['String']['output']>;
  paymentRequestReference?: Maybe<PaymentRequestReference>;
  pinCode?: Maybe<Scalars['String']['output']>;
  prepaid?: Maybe<Scalars['Boolean']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  totalPriceVat?: Maybe<Scalars['Float']['output']>;
  travelIntent?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
};

export type BookingEntityList = {
  __typename?: 'BookingEntityList';
  pagination?: Maybe<Pagination>;
  results?: Maybe<Array<Maybe<Booking>>>;
};

export type BookingHp = {
  __typename?: 'BookingHP';
  creationInfo?: Maybe<CreationInfo>;
  partner?: Maybe<Partner>;
  partnerId?: Maybe<Scalars['Int']['output']>;
};

export type BookingParams = {
  bookerInfo: BookerInfoParams;
  creationSource?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  partnerReference: Scalars['String']['input'];
  quotes: Array<InputMaybe<BookingQuoteParams>>;
  travelIntent: Scalars['String']['input'];
};

export type BookingQuoteParams = {
  quoteId: Scalars['Float']['input'];
  quoteTravelAddons: Array<InputMaybe<BookingQuoteTravelAddonParams>>;
  travellerInfo: TravellerInfoParams;
};

export type BookingQuoteTravelAddonParams = {
  amount: Scalars['Int']['input'];
  quoteTravelAddonId: Scalars['Float']['input'];
};

export type BookingsRequestParams = {
  bookingCode?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Comment = {
  body?: InputMaybe<Scalars['String']['input']>;
  uploads?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CommunicationPreferences = {
  __typename?: 'CommunicationPreferences';
  sendJourneyCancellationEmails?: Maybe<Scalars['Boolean']['output']>;
};

export type Country = {
  __typename?: 'Country';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  timezones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CreationInfo = {
  __typename?: 'CreationInfo';
  source?: Maybe<Scalars['String']['output']>;
};

export type Currency = {
  __typename?: 'Currency';
  currency?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

export type CustomField = {
  id?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomFieldOption = {
  __typename?: 'CustomFieldOption';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomerSupportInfo = {
  __typename?: 'CustomerSupportInfo';
  email?: Maybe<Scalars['String']['output']>;
  emergencyEmail?: Maybe<Scalars['String']['output']>;
  emergencyPhone?: Maybe<Scalars['String']['output']>;
  fullTimeSupport?: Maybe<Scalars['Boolean']['output']>;
  openingHoursFrom?: Maybe<Scalars['String']['output']>;
  openingHoursTo?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type Destination = {
  __typename?: 'Destination';
  address?: Maybe<Address>;
  hub?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Position>;
};

export type Distance = {
  __typename?: 'Distance';
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type DistanceInformation = {
  __typename?: 'DistanceInformation';
  distance?: Maybe<Scalars['Float']['output']>;
  durationInSeconds?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type Driver = {
  __typename?: 'Driver';
  id?: Maybe<Scalars['Int']['output']>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  mobilePhoneNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photoFileExternalKey?: Maybe<Scalars['String']['output']>;
};

export type EnvironmentConfigs = {
  __typename?: 'EnvironmentConfigs';
  adyenClientKey?: Maybe<Scalars['String']['output']>;
  adyenMerchant?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  googleMapsApiKey?: Maybe<Scalars['String']['output']>;
  googleMapsApiKeyHelpCenter?: Maybe<Scalars['String']['output']>;
  helpPortalLaunchDarklyId?: Maybe<Scalars['String']['output']>;
  launchDarklyId?: Maybe<Scalars['String']['output']>;
  sentryDSN?: Maybe<Scalars['String']['output']>;
  travellerAppUrl?: Maybe<Scalars['String']['output']>;
};

export type Fleet = {
  __typename?: 'Fleet';
  availableTravelAddons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  customerSupportInfo?: Maybe<CustomerSupportInfo>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offerEmail?: Maybe<Scalars['String']['output']>;
  timeZoneId?: Maybe<Scalars['String']['output']>;
  transferCompanyId?: Maybe<Scalars['Int']['output']>;
};

export type FlightDesignator = {
  __typename?: 'FlightDesignator';
  airlineCode?: Maybe<Scalars['String']['output']>;
  airlineName?: Maybe<Scalars['String']['output']>;
  flightNumber?: Maybe<Scalars['String']['output']>;
};

export type FlightInfo = {
  __typename?: 'FlightInfo';
  arrivalAirport?: Maybe<Airport>;
  departureAirport?: Maybe<Airport>;
  flightNumbers?: Maybe<Array<Maybe<FlightNumber>>>;
};

export type FlightInfoRequestParams = {
  arrivalAirportIataCode?: InputMaybe<Scalars['String']['input']>;
  arrivalDate?: InputMaybe<Scalars['String']['input']>;
  carrierIataCode?: InputMaybe<Scalars['String']['input']>;
  departureAirportIataCode?: InputMaybe<Scalars['String']['input']>;
  departureDate?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  iataFlightNumber?: InputMaybe<Scalars['String']['input']>;
};

export type FlightNumber = {
  __typename?: 'FlightNumber';
  carrierIataCode?: Maybe<Scalars['String']['output']>;
  flightNumber?: Maybe<Scalars['String']['output']>;
};

export type FlightsByHubIdsRequestParams = {
  arrivalDateTime?: InputMaybe<Scalars['String']['input']>;
  destinationHubId?: InputMaybe<Scalars['Int']['input']>;
  originHubId?: InputMaybe<Scalars['Int']['input']>;
};

export type FlightsInfo = {
  __typename?: 'FlightsInfo';
  flightDesignators?: Maybe<Array<Maybe<FlightDesignator>>>;
  originalArrivalTimeLocal?: Maybe<Scalars['String']['output']>;
  originalDepartureTimeLocal?: Maybe<Scalars['String']['output']>;
};

export type GeoCoordinate = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type GeographicArea = {
  __typename?: 'GeographicArea';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type HighlightedResult = {
  __typename?: 'HighlightedResult';
  autoCompleteLocation?: Maybe<HighlightedValue>;
  autoCompleteName?: Maybe<HighlightedValue>;
};

export type HighlightedValue = {
  __typename?: 'HighlightedValue';
  value?: Maybe<Scalars['String']['output']>;
};

export type Hub = {
  __typename?: 'Hub';
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Address>;
  autoCompleteLocation?: Maybe<Scalars['String']['output']>;
  autoCompleteName?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<Maybe<HubDetail>>>;
  geographicArea?: Maybe<Array<Maybe<GeographicArea>>>;
  hubDetails?: Maybe<AirportDetails>;
  hubType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  managedByUserId?: Maybe<Scalars['Int']['output']>;
  measurementSystem?: Maybe<Scalars['String']['output']>;
  minBookWindowHours?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  overrideJourneysDistributionDefaultPercentages?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Position>;
  timeZoneId?: Maybe<Scalars['String']['output']>;
  vatLevel?: Maybe<Scalars['Float']['output']>;
};

export type HubDetail = {
  __typename?: 'HubDetail';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type HubEntityList = {
  __typename?: 'HubEntityList';
  pagination?: Maybe<Pagination>;
  results?: Maybe<Array<Maybe<Hub>>>;
};

export type HubsRequestParams = {
  page: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};

export type IpAddressInfo = {
  __typename?: 'IPAddressInfo';
  continentCode?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryPhonePrefix?: Maybe<Scalars['String']['output']>;
  crawler?: Maybe<Scalars['Boolean']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  isp?: Maybe<Scalars['String']['output']>;
  proxy?: Maybe<Scalars['Boolean']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  tor?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InitiatePaymentResponse = {
  __typename?: 'InitiatePaymentResponse';
  paymentServicePaymentRequestId?: Maybe<Scalars['Int']['output']>;
};

export type Journey = {
  __typename?: 'Journey';
  booking?: Maybe<BookingHp>;
  bookingId?: Maybe<Scalars['Int']['output']>;
  canBeCompleted?: Maybe<Scalars['Boolean']['output']>;
  cancellationDetails?: Maybe<JourneyCancellationDetails>;
  created?: Maybe<Scalars['String']['output']>;
  destinationLocation?: Maybe<Location>;
  destinationLocationId?: Maybe<Scalars['Int']['output']>;
  driver?: Maybe<Driver>;
  fleet?: Maybe<Fleet>;
  hub?: Maybe<Hub>;
  hubId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inbound?: Maybe<Scalars['Boolean']['output']>;
  journeyChangesInfo?: Maybe<JourneyChangesInfo>;
  journeyCode?: Maybe<Scalars['String']['output']>;
  journeyExecutionInfo?: Maybe<JourneyExecutionInfo>;
  meetingPoint?: Maybe<MeetingPoint>;
  originLocation?: Maybe<Location>;
  originLocationId?: Maybe<Scalars['Int']['output']>;
  quote?: Maybe<Quote>;
  quoteId?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalFare?: Maybe<Scalars['Float']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  transferCompany?: Maybe<TransferCompany>;
  travelAddons?: Maybe<Array<Maybe<TravelAddon>>>;
  travellerInfo?: Maybe<TravellerInfo>;
  updated?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<Vehicle>;
};

export type JourneyCancellationDetails = {
  __typename?: 'JourneyCancellationDetails';
  cancellable?: Maybe<Scalars['Boolean']['output']>;
  freeCancellationUntil?: Maybe<Scalars['String']['output']>;
  freeCancellationWindowHours?: Maybe<Scalars['Int']['output']>;
};

export type JourneyCancellationParams = {
  acceptCharges?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  overrideCancellationWindow?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type JourneyChange = {
  __typename?: 'JourneyChange';
  changeAutomationType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isPaymentRequired?: Maybe<Scalars['Boolean']['output']>;
  paymentAmount?: Maybe<Scalars['Float']['output']>;
};

export type JourneyChangesInfo = {
  __typename?: 'JourneyChangesInfo';
  afterMinBookingWindow?: Maybe<Scalars['Boolean']['output']>;
};

export type JourneyEntityList = {
  __typename?: 'JourneyEntityList';
  results?: Maybe<Array<Maybe<Journey>>>;
};

export type JourneyExecutionInfo = {
  __typename?: 'JourneyExecutionInfo';
  assignedDriverId?: Maybe<Scalars['Int']['output']>;
  assignedDriverVehicleId?: Maybe<Scalars['Int']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Distance>;
  driverId?: Maybe<Scalars['Int']['output']>;
  durationInSeconds?: Maybe<Scalars['Int']['output']>;
  fleetId?: Maybe<Scalars['Int']['output']>;
  lastKnownDriverPosition?: Maybe<Position>;
  lastKnownDriverPositionUpdated?: Maybe<Scalars['String']['output']>;
  meetingPointId?: Maybe<Scalars['Int']['output']>;
  meetingPointType?: Maybe<Scalars['String']['output']>;
  pickupDate?: Maybe<Scalars['String']['output']>;
  pickupTimeZone?: Maybe<Scalars['String']['output']>;
  transferCompanyId?: Maybe<Scalars['Int']['output']>;
  vehicleCategory?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['Int']['output']>;
};

export type JourneyParams = {
  destinationLocation?: InputMaybe<LocationParams>;
  journeyId?: InputMaybe<Scalars['Int']['input']>;
  originLocation?: InputMaybe<LocationParams>;
  pickup?: InputMaybe<PickupParams>;
  travellerInfo?: InputMaybe<JourneyTravellerInfoParams>;
};

export type JourneyRequestParams = {
  bookingCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeCancellationDetails?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type JourneyTravellerInfoParams = {
  driverComments?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  luggageCount?: InputMaybe<Scalars['Float']['input']>;
  passengerCount?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  shipName?: InputMaybe<Scalars['String']['input']>;
  trainNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Address>;
  hub?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Position>;
};

export type LocationByGeoPositionInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  findNearestHub?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type LocationParams = {
  locationId: Scalars['Int']['input'];
};

export type MatchedSubstring = {
  __typename?: 'MatchedSubstring';
  length?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MeetingPoint = {
  __typename?: 'MeetingPoint';
  description?: Maybe<Scalars['String']['output']>;
  geographicLocation?: Maybe<Position>;
  hubTenderId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MultilingualHub = {
  __typename?: 'MultilingualHub';
  autoCompleteLocation?: Maybe<Scalars['String']['output']>;
  autoCompleteName?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  highlightedResult?: Maybe<HighlightedResult>;
  hubType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Position>;
};

export type MultilingualHubEntityList = {
  __typename?: 'MultilingualHubEntityList';
  pagination?: Maybe<Pagination>;
  results?: Maybe<Array<Maybe<MultilingualHub>>>;
};

export type MultilingualHubsRequestParams = {
  page: Scalars['Int']['input'];
  preferredLanguage: Scalars['String']['input'];
  query: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addTag?: Maybe<TagsResponse>;
  base?: Maybe<Scalars['String']['output']>;
  cancelJourney?: Maybe<Scalars['Void']['output']>;
  confirmJourneyChanges?: Maybe<Scalars['Void']['output']>;
  createBooking?: Maybe<Booking>;
  createRequest?: Maybe<RequestResponse>;
  deleteFile?: Maybe<Scalars['Void']['output']>;
  initiatePayment?: Maybe<InitiatePaymentResponse>;
  paymentResultCode?: Maybe<PaymentResultCodeResponse>;
  performPayment?: Maybe<PerformPaymentResponse>;
  processJourneyChanges?: Maybe<JourneyChange>;
  uploadFile?: Maybe<UploadFileResponse>;
};


export type MutationAddTagArgs = {
  params: TagParams;
};


export type MutationCancelJourneyArgs = {
  params: JourneyCancellationParams;
};


export type MutationConfirmJourneyChangesArgs = {
  id: Scalars['Int']['input'];
  overridePayment?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateBookingArgs = {
  params: BookingParams;
};


export type MutationCreateRequestArgs = {
  params: RequestParams;
};


export type MutationDeleteFileArgs = {
  token: Scalars['String']['input'];
};


export type MutationInitiatePaymentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPaymentResultCodeArgs = {
  id: Scalars['Int']['input'];
  params: PaymentResultCodeParams;
};


export type MutationPerformPaymentArgs = {
  id: Scalars['Int']['input'];
  params: PaymentParams;
};


export type MutationProcessJourneyChangesArgs = {
  params: JourneyParams;
};


export type MutationUploadFileArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
};

export type Organization = {
  __typename?: 'Organization';
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  currentPage?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type Partner = {
  __typename?: 'Partner';
  communicationPreferences?: Maybe<CommunicationPreferences>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PartnerConfigs = {
  __typename?: 'PartnerConfigs';
  applicationSettings?: Maybe<Scalars['JSONObject']['output']>;
  customPrefixUrl?: Maybe<Scalars['String']['output']>;
  environmentConfigs?: Maybe<EnvironmentConfigs>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onlineBookingToolEnabled?: Maybe<Scalars['Boolean']['output']>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  partnerWhiteLabel?: Maybe<PartnerWhiteLabel>;
  primaryUrl?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<PartnerConfigsSettings>;
  styling?: Maybe<Styling>;
  stylingOverrides?: Maybe<Array<Maybe<StylingOverride>>>;
  tagManagers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PartnerConfigsSettings = {
  __typename?: 'PartnerConfigsSettings';
  showHubFirst?: Maybe<Scalars['Boolean']['output']>;
};

export type PartnerWhiteLabel = {
  __typename?: 'PartnerWhiteLabel';
  fullDomainName?: Maybe<Scalars['String']['output']>;
  helpdeskUrl?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  brands?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  configuration?: Maybe<PaymentMethodConfiguration>;
  details?: Maybe<Array<Maybe<PaymentMethodDetails>>>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodConfiguration = {
  __typename?: 'PaymentMethodConfiguration';
  merchantId?: Maybe<Scalars['String']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodDetails = {
  __typename?: 'PaymentMethodDetails';
  items?: Maybe<Array<Maybe<PaymentMethodItem>>>;
  key?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodItem = {
  __typename?: 'PaymentMethodItem';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethods = {
  __typename?: 'PaymentMethods';
  paymentMethods?: Maybe<Array<Maybe<PaymentMethod>>>;
};

export type PaymentMethodsRequestParams = {
  countryCode: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  languageIsoCode?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentParams = {
  browserInfo?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  shopperEmail?: InputMaybe<Scalars['String']['input']>;
  shopperIP?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentRequestReference = {
  __typename?: 'PaymentRequestReference';
  paymentServicePaymentRequestId?: Maybe<Scalars['Int']['output']>;
};

export type PaymentResultCodeAmount = {
  __typename?: 'PaymentResultCodeAmount';
  currency?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type PaymentResultCodeParams = {
  details?: InputMaybe<Scalars['JSONObject']['input']>;
  paymentData?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentResultCodeResponse = {
  __typename?: 'PaymentResultCodeResponse';
  amount?: Maybe<PaymentResultCodeAmount>;
  merchantReference?: Maybe<Scalars['String']['output']>;
  pspReference?: Maybe<Scalars['String']['output']>;
  resultCode?: Maybe<Scalars['String']['output']>;
};

export type PerformPaymentResponse = {
  __typename?: 'PerformPaymentResponse';
  action?: Maybe<Scalars['JSONObject']['output']>;
  resultCode?: Maybe<Scalars['String']['output']>;
};

export type PickupParams = {
  pickupDate: Scalars['String']['input'];
};

export type Position = {
  __typename?: 'Position';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  __typename?: 'Query';
  IPAddressInfo?: Maybe<IpAddressInfo>;
  applicationSettings?: Maybe<ApplicationSettingEntityList>;
  article?: Maybe<ArticleInformation>;
  autoCompleteAddresses?: Maybe<Array<Maybe<AutoCompleteAddressItem>>>;
  base?: Maybe<Scalars['String']['output']>;
  booking?: Maybe<Booking>;
  clientIp?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  currencies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exchangeRate?: Maybe<Currency>;
  flightInfo?: Maybe<Array<Maybe<FlightInfo>>>;
  flightsByHubIds?: Maybe<AirportByIataCodeResponse>;
  getAirportByIATACode?: Maybe<AirportDetails>;
  hubById?: Maybe<Hub>;
  hubs?: Maybe<HubEntityList>;
  journeyHP?: Maybe<Journey>;
  journeysHP?: Maybe<JourneyEntityList>;
  locationByGeoPosition?: Maybe<Location>;
  locationByGooglePlaceId?: Maybe<Location>;
  multilingualHubs?: Maybe<MultilingualHubEntityList>;
  partnerConfigs?: Maybe<PartnerConfigs>;
  partnerWhiteLabel?: Maybe<PartnerWhiteLabel>;
  paymentMethods?: Maybe<PaymentMethods>;
  quotes?: Maybe<Array<Maybe<Quote>>>;
  roadDistance?: Maybe<DistanceInformation>;
  searchArticle?: Maybe<SearchArticleEntityList>;
  section?: Maybe<SectionInformation>;
  sections?: Maybe<SectionEntityList>;
  sessionData?: Maybe<SessionData>;
  ticketForms?: Maybe<TicketFormEntityList>;
  trackingData?: Maybe<TrackingData>;
  translations?: Maybe<Translations>;
};


export type QueryApplicationSettingsArgs = {
  params: ApplicationSettingsRequestParams;
};


export type QueryArticleArgs = {
  id?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAutoCompleteAddressesArgs = {
  params: AutoCompleteAddressesParams;
};


export type QueryBookingArgs = {
  bookingCode: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};


export type QueryCountryArgs = {
  timeZone: Scalars['String']['input'];
};


export type QueryExchangeRateArgs = {
  base: Scalars['String']['input'];
  currencyCode: Scalars['String']['input'];
};


export type QueryFlightInfoArgs = {
  params: FlightInfoRequestParams;
};


export type QueryFlightsByHubIdsArgs = {
  params: FlightsByHubIdsRequestParams;
};


export type QueryGetAirportByIataCodeArgs = {
  params: AirportByIataCodeRequestParams;
};


export type QueryHubByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryHubsArgs = {
  params: HubsRequestParams;
};


export type QueryJourneyHpArgs = {
  id: Scalars['Int']['input'];
  includeCancellationDetails?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryJourneysHpArgs = {
  bookingCode: Scalars['String']['input'];
};


export type QueryLocationByGeoPositionArgs = {
  data: LocationByGeoPositionInput;
};


export type QueryLocationByGooglePlaceIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryMultilingualHubsArgs = {
  params: MultilingualHubsRequestParams;
};


export type QueryPartnerConfigsArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPartnerWhiteLabelArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaymentMethodsArgs = {
  params: PaymentMethodsRequestParams;
};


export type QueryQuotesArgs = {
  params: RetrieveQuotesParams;
};


export type QueryRoadDistanceArgs = {
  arrivalDateTime?: InputMaybe<Scalars['String']['input']>;
  departureDateTime?: InputMaybe<Scalars['String']['input']>;
  destination: GeoCoordinate;
  measurementSystem: Scalars['String']['input'];
  origin: GeoCoordinate;
};


export type QuerySearchArticleArgs = {
  params: SearchArticleRequestParams;
};


export type QuerySectionArgs = {
  id?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySectionsArgs = {
  lng?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySessionDataArgs = {
  bookingCode: Scalars['String']['input'];
  bookingId: Scalars['Int']['input'];
};


export type QueryTicketFormsArgs = {
  lng?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTrackingDataArgs = {
  bookingCode?: InputMaybe<Scalars['String']['input']>;
  hubName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTranslationsArgs = {
  app: Scalars['String']['input'];
  lng: Scalars['String']['input'];
};

export type Quote = {
  __typename?: 'Quote';
  combinedBabyAndBoosterSeatsCapacity?: Maybe<Scalars['Int']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ids?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  includedWaitingTimeInMinutes?: Maybe<Scalars['Int']['output']>;
  luggageCapacity?: Maybe<Scalars['Int']['output']>;
  passengerCapacity?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  pricePerPassenger?: Maybe<Scalars['Float']['output']>;
  requestId?: Maybe<Scalars['Int']['output']>;
  travelAddons?: Maybe<Array<Maybe<QuoteTravelAddon>>>;
  vehicleCategory?: Maybe<Scalars['String']['output']>;
  vehicleModels?: Maybe<Scalars['String']['output']>;
  vehicleRating?: Maybe<VehicleRating>;
};

export type QuotePrice = {
  __typename?: 'QuotePrice';
  fareVat?: Maybe<Scalars['Float']['output']>;
  partnerMargin?: Maybe<Scalars['Float']['output']>;
  partnerMarginVat?: Maybe<Scalars['Float']['output']>;
  platformMargin?: Maybe<Scalars['Float']['output']>;
  platformMarginVat?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

export type QuoteTravelAddon = {
  __typename?: 'QuoteTravelAddon';
  fare?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  maxAllowed?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<QuotePrice>;
  quoteTravelAddonIdPairs?: Maybe<Scalars['JSONObject']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Request = {
  comment?: InputMaybe<Comment>;
  custom_fields?: InputMaybe<Array<InputMaybe<CustomField>>>;
  requester?: InputMaybe<Requester>;
  subject?: InputMaybe<Scalars['String']['input']>;
  ticket_form_id?: InputMaybe<Scalars['Float']['input']>;
};

export type RequestAttachment = {
  file_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type RequestInfo = {
  __typename?: 'RequestInfo';
  custom_fields?: Maybe<Scalars['JSONObject']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Scalars['JSONObject']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  requester_id?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  ticket_form_id?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type RequestParams = {
  request?: InputMaybe<Request>;
};

export type RequestResponse = {
  __typename?: 'RequestResponse';
  request?: Maybe<RequestInfo>;
};

export type Requester = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RetrieveQuotesParams = {
  adultPassengerCount?: InputMaybe<Scalars['Int']['input']>;
  childPassengerCount?: InputMaybe<Scalars['Int']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  directionality?: InputMaybe<Scalars['String']['input']>;
  hub?: InputMaybe<Scalars['Int']['input']>;
  inboundPickup?: InputMaybe<Scalars['String']['input']>;
  infantPassengerCount?: InputMaybe<Scalars['Int']['input']>;
  isRoundTrip?: InputMaybe<Scalars['Boolean']['input']>;
  luggage?: InputMaybe<Scalars['Int']['input']>;
  outboundPickup?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  passengers?: InputMaybe<Scalars['Int']['input']>;
  preferredCurrencyCode?: InputMaybe<Scalars['String']['input']>;
};

export type SearchArticleEntityList = {
  __typename?: 'SearchArticleEntityList';
  count?: Maybe<Scalars['Int']['output']>;
  next_page?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  page_count?: Maybe<Scalars['Int']['output']>;
  per_page?: Maybe<Scalars['Int']['output']>;
  previous_page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Article>>>;
  sort_by?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['String']['output']>;
};

export type SearchArticleRequestParams = {
  locale?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type Section = {
  __typename?: 'Section';
  articles?: Maybe<ArticleEntityList>;
  category_id?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  html_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  outdated?: Maybe<Scalars['Boolean']['output']>;
  parent_section_id?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  source_locale?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SectionEntityList = {
  __typename?: 'SectionEntityList';
  count?: Maybe<Scalars['Int']['output']>;
  next_page?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  page_count?: Maybe<Scalars['Int']['output']>;
  per_page?: Maybe<Scalars['Int']['output']>;
  previous_page?: Maybe<Scalars['Int']['output']>;
  sections?: Maybe<Array<Maybe<Section>>>;
  sort_by?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['String']['output']>;
};

export type SectionInformation = {
  __typename?: 'SectionInformation';
  section?: Maybe<Section>;
};

export type SessionData = {
  __typename?: 'SessionData';
  adultPassengerCount?: Maybe<Scalars['Int']['output']>;
  bookerInfo?: Maybe<BookerInfo>;
  childPassengerCount?: Maybe<Scalars['Int']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<Destination>;
  directionality?: Maybe<Scalars['String']['output']>;
  hub?: Maybe<Hub>;
  inboundPickupTime?: Maybe<Scalars['String']['output']>;
  infantPassengerCount?: Maybe<Scalars['Int']['output']>;
  luggageCount?: Maybe<Scalars['Int']['output']>;
  outboundPickupTime?: Maybe<Scalars['String']['output']>;
  passengerCount?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  travelAddons?: Maybe<Scalars['JSONObject']['output']>;
  travellerInfo?: Maybe<TravellerInfo>;
  vehicleCategory?: Maybe<Scalars['String']['output']>;
};

export type Styling = {
  __typename?: 'Styling';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundContrastColor?: Maybe<Scalars['String']['output']>;
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  primaryContrastColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  secondaryContrastColor?: Maybe<Scalars['String']['output']>;
  tertiaryColor?: Maybe<Scalars['String']['output']>;
  tertiaryContrastColor?: Maybe<Scalars['String']['output']>;
};

export type StylingOverride = {
  __typename?: 'StylingOverride';
  code?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TagParams = {
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketId?: InputMaybe<Scalars['Float']['input']>;
};

export type TagsResponse = {
  __typename?: 'TagsResponse';
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TicketField = {
  __typename?: 'TicketField';
  active?: Maybe<Scalars['Boolean']['output']>;
  agent_description?: Maybe<Scalars['String']['output']>;
  collapsed_for_agents?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  custom_field_options?: Maybe<Array<Maybe<CustomFieldOption>>>;
  description?: Maybe<Scalars['String']['output']>;
  editable_in_portal?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  raw_description?: Maybe<Scalars['String']['output']>;
  raw_title?: Maybe<Scalars['String']['output']>;
  raw_title_in_portal?: Maybe<Scalars['String']['output']>;
  regexp_for_validation?: Maybe<Scalars['String']['output']>;
  removable?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  required_in_portal?: Maybe<Scalars['Boolean']['output']>;
  sub_type_id?: Maybe<Scalars['Int']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_in_portal?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  visible_in_portal?: Maybe<Scalars['String']['output']>;
};

export type TicketFieldResponse = {
  __typename?: 'TicketFieldResponse';
  ticket_field?: Maybe<TicketField>;
};

export type TicketForm = {
  __typename?: 'TicketForm';
  active?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  in_all_brands?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  raw_display_name?: Maybe<Scalars['String']['output']>;
  raw_name?: Maybe<Scalars['String']['output']>;
  restricted_brand_ids?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  ticket_field_ids?: Maybe<Array<Maybe<TicketFieldResponse>>>;
  updated_at?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type TicketFormTicket_Field_IdsArgs = {
  lng?: InputMaybe<Scalars['String']['input']>;
};

export type TicketFormEntityList = {
  __typename?: 'TicketFormEntityList';
  count?: Maybe<Scalars['Int']['output']>;
  next_page?: Maybe<Scalars['Int']['output']>;
  previous_page?: Maybe<Scalars['Int']['output']>;
  ticket_forms?: Maybe<Array<Maybe<TicketForm>>>;
};

export type TrackingData = {
  __typename?: 'TrackingData';
  commission?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  hub_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  items?: Maybe<Array<Maybe<TrackingDataItem>>>;
  order_date?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  payment_status?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  transaction_id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type TrackingDataItem = {
  __typename?: 'TrackingDataItem';
  adultPassengerCount?: Maybe<Scalars['Int']['output']>;
  childPassengerCount?: Maybe<Scalars['Int']['output']>;
  commission?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  inbound?: Maybe<Scalars['Boolean']['output']>;
  infantPassengerCount?: Maybe<Scalars['Int']['output']>;
  item_characteristics?: Maybe<Scalars['String']['output']>;
  item_id?: Maybe<Scalars['String']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  luggage?: Maybe<Scalars['Int']['output']>;
  passengers?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceTax?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type TransferCompany = {
  __typename?: 'TransferCompany';
  ibanAccountHolder?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  licenseExpiry?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  paymentTermsDays?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type TransferCompanyParamsInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  fleetId?: InputMaybe<Scalars['Int']['input']>;
  invoicingFrequency?: InputMaybe<Scalars['String']['input']>;
  managedByUserName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardingStatus?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Translations = {
  __typename?: 'Translations';
  content?: Maybe<Scalars['JSONObject']['output']>;
  languageCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TravelAddon = {
  __typename?: 'TravelAddon';
  amount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TravellerInfo = {
  __typename?: 'TravellerInfo';
  adultPassengerCount?: Maybe<Scalars['Int']['output']>;
  allowedToModifyJourney?: Maybe<Scalars['Boolean']['output']>;
  childPassengerCount?: Maybe<Scalars['Int']['output']>;
  driverComments?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  flightNumber?: Maybe<Scalars['String']['output']>;
  infantPassengerCount?: Maybe<Scalars['Int']['output']>;
  languageIsoCode?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  luggageCount?: Maybe<Scalars['Int']['output']>;
  meetAndGreetSignText?: Maybe<Scalars['String']['output']>;
  passengerCount?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  shipName?: Maybe<Scalars['String']['output']>;
  trainNumber?: Maybe<Scalars['String']['output']>;
};

export type TravellerInfoParams = {
  allowedToModifyJourney?: InputMaybe<Scalars['Boolean']['input']>;
  driverComments?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  languageIsoCode?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  meetAndGreetSignText?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  residenceCountryCode?: InputMaybe<Scalars['String']['input']>;
  shipName?: InputMaybe<Scalars['String']['input']>;
  trainNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  attachment?: Maybe<Attachment>;
  expires_at?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type UploadFileResponse = {
  __typename?: 'UploadFileResponse';
  upload?: Maybe<UploadFile>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  category?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  vehicleMake?: Maybe<Scalars['String']['output']>;
  vehicleModel?: Maybe<Scalars['String']['output']>;
  vehicleSeries?: Maybe<Scalars['String']['output']>;
};

export type VehicleRating = {
  __typename?: 'VehicleRating';
  count?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  vehicleCategory?: Maybe<Scalars['String']['output']>;
};

export type AutoCompleteAddressesQueryVariables = Exact<{
  params: AutoCompleteAddressesParams;
}>;


export type AutoCompleteAddressesQuery = { __typename?: 'Query', autoCompleteAddresses?: Array<{ __typename?: 'AutoCompleteAddressItem', title: string, subtitle: string, formattedAddress: string, type: string, hubId?: number | null, googlePlaceId?: string | null, hereId?: string | null } | null> | null };

export type BookingQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  bookingCode: Scalars['String']['input'];
}>;


export type BookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', paymentRequestReference?: { __typename?: 'PaymentRequestReference', paymentServicePaymentRequestId?: number | null } | null, bookerInfo?: { __typename?: 'BookerInfo', email?: string | null } | null } | null };

export type CreateBookingMutationVariables = Exact<{
  params: BookingParams;
}>;


export type CreateBookingMutation = { __typename?: 'Mutation', createBooking?: { __typename?: 'Booking', id?: number | null, created?: string | null, code?: string | null, pinCode?: string | null, totalPrice?: number | null, travelIntent?: string | null, partnerReference?: string | null, currencyCode?: string | null, bookerInfo?: { __typename?: 'BookerInfo', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, companyName?: string | null, reference?: string | null, traveller?: boolean | null, receiveJourneyUpdates?: boolean | null, languageIsoCode?: string | null } | null } | null };

export type CountryQueryVariables = Exact<{
  timeZone: Scalars['String']['input'];
}>;


export type CountryQuery = { __typename?: 'Query', country?: { __typename?: 'Country', id?: string | null } | null };

export type CurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrenciesQuery = { __typename?: 'Query', currencies?: Array<string | null> | null };

export type ExchangeRateQueryVariables = Exact<{
  currencyCode: Scalars['String']['input'];
  base: Scalars['String']['input'];
}>;


export type ExchangeRateQuery = { __typename?: 'Query', exchangeRate?: { __typename?: 'Currency', rate?: number | null, currency?: string | null } | null };

export type RoadDistanceQueryVariables = Exact<{
  origin: GeoCoordinate;
  destination: GeoCoordinate;
  measurementSystem: Scalars['String']['input'];
  arrivalDateTime?: InputMaybe<Scalars['String']['input']>;
  departureDateTime?: InputMaybe<Scalars['String']['input']>;
}>;


export type RoadDistanceQuery = { __typename?: 'Query', roadDistance?: { __typename?: 'DistanceInformation', distance?: number | null, durationInSeconds?: number | null, unit?: string | null } | null };

export type HubsQueryVariables = Exact<{
  params: HubsRequestParams;
}>;


export type HubsQuery = { __typename?: 'Query', hubs?: { __typename?: 'HubEntityList', results?: Array<{ __typename?: 'Hub', id?: number | null, hubType?: string | null, autoCompleteName?: string | null, autoCompleteLocation?: string | null, position?: { __typename?: 'Position', lat?: number | null, lng?: number | null } | null } | null> | null, pagination?: { __typename?: 'Pagination', currentPage?: number | null, pageSize?: number | null, totalPages?: number | null, totalResults?: number | null } | null } | null };

export type GetHubByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetHubByIdQuery = { __typename?: 'Query', hubById?: { __typename?: 'Hub', id?: number | null, details?: Array<{ __typename?: 'HubDetail', code?: string | null, value?: string | null } | null> | null, position?: { __typename?: 'Position', lat?: number | null, lng?: number | null } | null, hubDetails?: { __typename?: 'AirportDetails', name?: string | null, iataCode?: string | null, cityName?: string | null, countryCode?: string | null } | null } | null };

export type MultilingualHubsQueryVariables = Exact<{
  params: MultilingualHubsRequestParams;
}>;


export type MultilingualHubsQuery = { __typename?: 'Query', multilingualHubs?: { __typename?: 'MultilingualHubEntityList', results?: Array<{ __typename?: 'MultilingualHub', id?: number | null, autoCompleteName?: string | null, autoCompleteLocation?: string | null, hubType?: string | null, countryCode?: string | null, position?: { __typename?: 'Position', lat?: number | null, lng?: number | null } | null, highlightedResult?: { __typename?: 'HighlightedResult', autoCompleteName?: { __typename?: 'HighlightedValue', value?: string | null } | null, autoCompleteLocation?: { __typename?: 'HighlightedValue', value?: string | null } | null } | null } | null> | null, pagination?: { __typename?: 'Pagination', currentPage?: number | null, pageSize?: number | null, totalPages?: number | null, totalResults?: number | null } | null } | null };

export type ClientIpQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientIpQuery = { __typename?: 'Query', clientIp?: string | null };

export type IpAddressInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type IpAddressInfoQuery = { __typename?: 'Query', IPAddressInfo?: { __typename?: 'IPAddressInfo', ipAddress?: string | null, type?: string | null, continentCode?: string | null, countryCode?: string | null, regionCode?: string | null, countryPhonePrefix?: string | null, timeZone?: string | null, currencyCode?: string | null, isp?: string | null, proxy?: boolean | null, crawler?: boolean | null, tor?: boolean | null } | null };

export type PartnerConfigsQueryVariables = Exact<{
  domain?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerConfigsQuery = { __typename?: 'Query', partnerConfigs?: { __typename?: 'PartnerConfigs', id?: number | null, name?: string | null, partnerId?: number | null, customPrefixUrl?: string | null, applicationSettings?: any | null, tagManagers?: Array<string | null> | null, primaryUrl?: string | null, onlineBookingToolEnabled?: boolean | null, styling?: { __typename?: 'Styling', backgroundColor?: string | null, backgroundContrastColor?: string | null, primaryColor?: string | null, primaryContrastColor?: string | null, secondaryColor?: string | null, secondaryContrastColor?: string | null, tertiaryColor?: string | null, tertiaryContrastColor?: string | null, logoUrl?: string | null, heroImageUrl?: string | null } | null, settings?: { __typename?: 'PartnerConfigsSettings', showHubFirst?: boolean | null } | null, stylingOverrides?: Array<{ __typename?: 'StylingOverride', code?: string | null, value?: string | null } | null> | null, environmentConfigs?: { __typename?: 'EnvironmentConfigs', googleMapsApiKey?: string | null, adyenClientKey?: string | null, adyenMerchant?: string | null, environment?: string | null, sentryDSN?: string | null } | null } | null };

export type PerformPaymentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: PaymentParams;
}>;


export type PerformPaymentMutation = { __typename?: 'Mutation', performPayment?: { __typename?: 'PerformPaymentResponse', action?: any | null, resultCode?: string | null } | null };

export type InitiatePaymentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type InitiatePaymentMutation = { __typename?: 'Mutation', initiatePayment?: { __typename?: 'InitiatePaymentResponse', paymentServicePaymentRequestId?: number | null } | null };

export type PaymentResultCodeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: PaymentResultCodeParams;
}>;


export type PaymentResultCodeMutation = { __typename?: 'Mutation', paymentResultCode?: { __typename?: 'PaymentResultCodeResponse', pspReference?: string | null, resultCode?: string | null, merchantReference?: string | null, amount?: { __typename?: 'PaymentResultCodeAmount', value?: number | null, currency?: string | null } | null } | null };

export type PaymentMethodsQueryVariables = Exact<{
  params: PaymentMethodsRequestParams;
}>;


export type PaymentMethodsQuery = { __typename?: 'Query', paymentMethods?: { __typename?: 'PaymentMethods', paymentMethods?: Array<{ __typename?: 'PaymentMethod', name?: string | null, type?: string | null, brands?: Array<string | null> | null, details?: Array<{ __typename?: 'PaymentMethodDetails', key?: string | null, type?: string | null, items?: Array<{ __typename?: 'PaymentMethodItem', id?: string | null, name?: string | null } | null> | null } | null> | null, configuration?: { __typename?: 'PaymentMethodConfiguration', merchantId?: string | null, merchantName?: string | null } | null } | null> | null } | null };

export type QuotesQueryVariables = Exact<{
  params: RetrieveQuotesParams;
}>;


export type QuotesQuery = { __typename?: 'Query', quotes?: Array<{ __typename?: 'Quote', vehicleCategory?: string | null, passengerCapacity?: number | null, luggageCapacity?: number | null, pricePerPassenger?: number | null, ids?: Array<number | null> | null, price?: number | null, requestId?: number | null, discount?: number | null, combinedBabyAndBoosterSeatsCapacity?: number | null, currencyCode?: string | null, includedWaitingTimeInMinutes?: number | null, vehicleModels?: string | null, vehicleRating?: { __typename?: 'VehicleRating', rating?: number | null, count?: number | null } | null, travelAddons?: Array<{ __typename?: 'QuoteTravelAddon', type?: string | null, fare?: number | null, quoteTravelAddonIdPairs?: any | null, maxAllowed?: number | null, price?: { __typename?: 'QuotePrice', price?: number | null, vat?: number | null, fareVat?: number | null, partnerMargin?: number | null, partnerMarginVat?: number | null, platformMargin?: number | null, platformMarginVat?: number | null } | null } | null> | null } | null> | null };

export type SessionDataQueryVariables = Exact<{
  bookingId: Scalars['Int']['input'];
  bookingCode: Scalars['String']['input'];
}>;


export type SessionDataQuery = { __typename?: 'Query', sessionData?: { __typename?: 'SessionData', vehicleCategory?: string | null, directionality?: string | null, totalPrice?: number | null, currencyCode?: string | null, travelAddons?: any | null, passengerCount?: number | null, adultPassengerCount?: number | null, infantPassengerCount?: number | null, childPassengerCount?: number | null, luggageCount?: number | null, inboundPickupTime?: string | null, outboundPickupTime?: string | null, hub?: { __typename?: 'Hub', id?: number | null, name?: string | null, managedByUserId?: number | null, active?: boolean | null, hubType?: string | null, minBookWindowHours?: number | null, autoCompleteName?: string | null, autoCompleteLocation?: string | null, position?: { __typename?: 'Position', lat?: number | null, lng?: number | null } | null, address?: { __typename?: 'Address', formattedAddress?: string | null, streetName?: string | null, streetNumber?: string | null, city?: string | null, postalCode?: string | null, region?: string | null, countryCode?: string | null, establishment?: string | null } | null, details?: Array<{ __typename?: 'HubDetail', code?: string | null, value?: string | null, name?: string | null } | null> | null, geographicArea?: Array<{ __typename?: 'GeographicArea', lat?: number | null, lng?: number | null } | null> | null } | null, destination?: { __typename?: 'Destination', id?: number | null, hub?: boolean | null, position?: { __typename?: 'Position', lat?: number | null, lng?: number | null } | null, address?: { __typename?: 'Address', formattedAddress?: string | null, streetName?: string | null, streetNumber?: string | null, city?: string | null, postalCode?: string | null, region?: string | null, countryCode?: string | null, establishment?: string | null } | null } | null, bookerInfo?: { __typename?: 'BookerInfo', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, companyName?: string | null, reference?: string | null, traveller?: boolean | null, receiveJourneyUpdates?: boolean | null, languageIsoCode?: string | null } | null, travellerInfo?: { __typename?: 'TravellerInfo', passengerCount?: number | null, adultPassengerCount?: number | null, infantPassengerCount?: number | null, childPassengerCount?: number | null, luggageCount?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, meetAndGreetSignText?: string | null, driverComments?: string | null, flightNumber?: string | null, trainNumber?: string | null, languageIsoCode?: string | null } | null } | null };

export type TrackingDataQueryVariables = Exact<{
  bookingCode?: InputMaybe<Scalars['String']['input']>;
  hubName?: InputMaybe<Scalars['String']['input']>;
}>;


export type TrackingDataQuery = { __typename?: 'Query', trackingData?: { __typename?: 'TrackingData', event?: string | null, currency?: string | null, value?: number | null, tax?: number | null, commission?: number | null, transaction_id?: string | null, payment_method?: string | null, payment_status?: string | null, order_date?: string | null, hub_ids?: Array<number | null> | null, items?: Array<{ __typename?: 'TrackingDataItem', price?: number | null, priceTax?: number | null, currency?: string | null, quantity?: number | null, commission?: number | null, inbound?: boolean | null, passengers?: number | null, luggage?: number | null, item_id?: string | null, item_name?: string | null, item_characteristics?: string | null } | null> | null } | null };

export type FlightInfoQueryVariables = Exact<{
  params: FlightInfoRequestParams;
  skip: Scalars['Boolean']['input'];
}>;


export type FlightInfoQuery = { __typename?: 'Query', flightInfo?: Array<{ __typename?: 'FlightInfo', flightNumbers?: Array<{ __typename?: 'FlightNumber', flightNumber?: string | null } | null> | null } | null> | null };

export type FlightsByHubIdsQueryVariables = Exact<{
  params: FlightsByHubIdsRequestParams;
}>;


export type FlightsByHubIdsQuery = { __typename?: 'Query', flightsByHubIds?: { __typename?: 'AirportByIATACodeResponse', flightDetails?: Array<{ __typename?: 'FlightsInfo', originalDepartureTimeLocal?: string | null, originalArrivalTimeLocal?: string | null, flightDesignators?: Array<{ __typename?: 'FlightDesignator', airlineCode?: string | null, flightNumber?: string | null, airlineName?: string | null } | null> | null } | null> | null, originHubDetails?: { __typename?: 'AirportDetails', name?: string | null, iataCode?: string | null, cityName?: string | null, countryCode?: string | null } | null } | null };

export type TranslationsQueryVariables = Exact<{
  app: Scalars['String']['input'];
  lng: Scalars['String']['input'];
}>;


export type TranslationsQuery = { __typename?: 'Query', translations?: { __typename?: 'Translations', content?: any | null, languageCodes?: Array<string | null> | null } | null };


export const AutoCompleteAddressesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutoCompleteAddresses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AutoCompleteAddressesParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoCompleteAddresses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hubId"}},{"kind":"Field","name":{"kind":"Name","value":"googlePlaceId"}},{"kind":"Field","name":{"kind":"Name","value":"hereId"}}]}}]}}]} as unknown as DocumentNode<AutoCompleteAddressesQuery, AutoCompleteAddressesQueryVariables>;
export const BookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Booking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"bookingCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRequestReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentServicePaymentRequestId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookerInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<BookingQuery, BookingQueryVariables>;
export const CreateBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"bookerInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"traveller"}},{"kind":"Field","name":{"kind":"Name","value":"receiveJourneyUpdates"}},{"kind":"Field","name":{"kind":"Name","value":"languageIsoCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"pinCode"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"travelIntent"}},{"kind":"Field","name":{"kind":"Name","value":"partnerReference"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}}]} as unknown as DocumentNode<CreateBookingMutation, CreateBookingMutationVariables>;
export const CountryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"country"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeZone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CountryQuery, CountryQueryVariables>;
export const CurrenciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Currencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencies"}}]}}]} as unknown as DocumentNode<CurrenciesQuery, CurrenciesQueryVariables>;
export const ExchangeRateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExchangeRate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currencyCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"base"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exchangeRate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currencyCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currencyCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"base"},"value":{"kind":"Variable","name":{"kind":"Name","value":"base"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]} as unknown as DocumentNode<ExchangeRateQuery, ExchangeRateQueryVariables>;
export const RoadDistanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RoadDistance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"origin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GeoCoordinate"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GeoCoordinate"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"measurementSystem"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"arrivalDateTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departureDateTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadDistance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"origin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"origin"}}},{"kind":"Argument","name":{"kind":"Name","value":"destination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destination"}}},{"kind":"Argument","name":{"kind":"Name","value":"measurementSystem"},"value":{"kind":"Variable","name":{"kind":"Name","value":"measurementSystem"}}},{"kind":"Argument","name":{"kind":"Name","value":"arrivalDateTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"arrivalDateTime"}}},{"kind":"Argument","name":{"kind":"Name","value":"departureDateTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departureDateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"durationInSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]} as unknown as DocumentNode<RoadDistanceQuery, RoadDistanceQueryVariables>;
export const HubsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Hubs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HubsRequestParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hubs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hubType"}},{"kind":"Field","name":{"kind":"Name","value":"autoCompleteName"}},{"kind":"Field","name":{"kind":"Name","value":"autoCompleteLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]}}]} as unknown as DocumentNode<HubsQuery, HubsQueryVariables>;
export const GetHubByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetHubById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hubById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hubDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iataCode"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}}]} as unknown as DocumentNode<GetHubByIdQuery, GetHubByIdQueryVariables>;
export const MultilingualHubsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MultilingualHubs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MultilingualHubsRequestParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"multilingualHubs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"autoCompleteName"}},{"kind":"Field","name":{"kind":"Name","value":"autoCompleteLocation"}},{"kind":"Field","name":{"kind":"Name","value":"hubType"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"highlightedResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoCompleteName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"autoCompleteLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]}}]} as unknown as DocumentNode<MultilingualHubsQuery, MultilingualHubsQueryVariables>;
export const ClientIpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"clientIp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientIp"}}]}}]} as unknown as DocumentNode<ClientIpQuery, ClientIpQueryVariables>;
export const IpAddressInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IPAddressInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"IPAddressInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"continentCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"regionCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryPhonePrefix"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"isp"}},{"kind":"Field","name":{"kind":"Name","value":"proxy"}},{"kind":"Field","name":{"kind":"Name","value":"crawler"}},{"kind":"Field","name":{"kind":"Name","value":"tor"}}]}}]}}]} as unknown as DocumentNode<IpAddressInfoQuery, IpAddressInfoQueryVariables>;
export const PartnerConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerConfigs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domain"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"partnerId"}},{"kind":"Field","name":{"kind":"Name","value":"customPrefixUrl"}},{"kind":"Field","name":{"kind":"Name","value":"applicationSettings"}},{"kind":"Field","name":{"kind":"Name","value":"styling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundContrastColor"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"primaryContrastColor"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryContrastColor"}},{"kind":"Field","name":{"kind":"Name","value":"tertiaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"tertiaryContrastColor"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showHubFirst"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stylingOverrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tagManagers"}},{"kind":"Field","name":{"kind":"Name","value":"primaryUrl"}},{"kind":"Field","name":{"kind":"Name","value":"onlineBookingToolEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"environmentConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"googleMapsApiKey"}},{"kind":"Field","name":{"kind":"Name","value":"adyenClientKey"}},{"kind":"Field","name":{"kind":"Name","value":"adyenMerchant"}},{"kind":"Field","name":{"kind":"Name","value":"environment"}},{"kind":"Field","name":{"kind":"Name","value":"sentryDSN"}}]}}]}}]}}]} as unknown as DocumentNode<PartnerConfigsQuery, PartnerConfigsQueryVariables>;
export const PerformPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PerformPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"performPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"resultCode"}}]}}]}}]} as unknown as DocumentNode<PerformPaymentMutation, PerformPaymentMutationVariables>;
export const InitiatePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitiatePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiatePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentServicePaymentRequestId"}}]}}]}}]} as unknown as DocumentNode<InitiatePaymentMutation, InitiatePaymentMutationVariables>;
export const PaymentResultCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PaymentResultCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentResultCodeParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentResultCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pspReference"}},{"kind":"Field","name":{"kind":"Name","value":"resultCode"}},{"kind":"Field","name":{"kind":"Name","value":"merchantReference"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<PaymentResultCodeMutation, PaymentResultCodeMutationVariables>;
export const PaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentMethodsRequestParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"brands"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchantId"}},{"kind":"Field","name":{"kind":"Name","value":"merchantName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export const QuotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Quotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RetrieveQuotesParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vehicleCategory"}},{"kind":"Field","name":{"kind":"Name","value":"vehicleRating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"passengerCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"luggageCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerPassenger"}},{"kind":"Field","name":{"kind":"Name","value":"ids"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"combinedBabyAndBoosterSeatsCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"travelAddons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"fare"}},{"kind":"Field","name":{"kind":"Name","value":"quoteTravelAddonIdPairs"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"vat"}},{"kind":"Field","name":{"kind":"Name","value":"fareVat"}},{"kind":"Field","name":{"kind":"Name","value":"partnerMargin"}},{"kind":"Field","name":{"kind":"Name","value":"partnerMarginVat"}},{"kind":"Field","name":{"kind":"Name","value":"platformMargin"}},{"kind":"Field","name":{"kind":"Name","value":"platformMarginVat"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxAllowed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"includedWaitingTimeInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"vehicleModels"}}]}}]}}]} as unknown as DocumentNode<QuotesQuery, QuotesQueryVariables>;
export const SessionDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SessionData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"bookingCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hub"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"establishment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"managedByUserId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"hubType"}},{"kind":"Field","name":{"kind":"Name","value":"minBookWindowHours"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geographicArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"autoCompleteName"}},{"kind":"Field","name":{"kind":"Name","value":"autoCompleteLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicleCategory"}},{"kind":"Field","name":{"kind":"Name","value":"directionality"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"travelAddons"}},{"kind":"Field","name":{"kind":"Name","value":"destination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"establishment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hub"}}]}},{"kind":"Field","name":{"kind":"Name","value":"passengerCount"}},{"kind":"Field","name":{"kind":"Name","value":"adultPassengerCount"}},{"kind":"Field","name":{"kind":"Name","value":"infantPassengerCount"}},{"kind":"Field","name":{"kind":"Name","value":"childPassengerCount"}},{"kind":"Field","name":{"kind":"Name","value":"luggageCount"}},{"kind":"Field","name":{"kind":"Name","value":"inboundPickupTime"}},{"kind":"Field","name":{"kind":"Name","value":"outboundPickupTime"}},{"kind":"Field","name":{"kind":"Name","value":"bookerInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"traveller"}},{"kind":"Field","name":{"kind":"Name","value":"receiveJourneyUpdates"}},{"kind":"Field","name":{"kind":"Name","value":"languageIsoCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"travellerInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"passengerCount"}},{"kind":"Field","name":{"kind":"Name","value":"adultPassengerCount"}},{"kind":"Field","name":{"kind":"Name","value":"infantPassengerCount"}},{"kind":"Field","name":{"kind":"Name","value":"childPassengerCount"}},{"kind":"Field","name":{"kind":"Name","value":"luggageCount"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"meetAndGreetSignText"}},{"kind":"Field","name":{"kind":"Name","value":"driverComments"}},{"kind":"Field","name":{"kind":"Name","value":"flightNumber"}},{"kind":"Field","name":{"kind":"Name","value":"trainNumber"}},{"kind":"Field","name":{"kind":"Name","value":"languageIsoCode"}}]}}]}}]}}]} as unknown as DocumentNode<SessionDataQuery, SessionDataQueryVariables>;
export const TrackingDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrackingData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hubName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackingData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookingCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"hubName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hubName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"commission"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceTax"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"commission"}},{"kind":"Field","name":{"kind":"Name","value":"inbound"}},{"kind":"Field","name":{"kind":"Name","value":"passengers"}},{"kind":"Field","name":{"kind":"Name","value":"luggage"}},{"kind":"Field","name":{"kind":"Name","value":"item_id"}},{"kind":"Field","name":{"kind":"Name","value":"item_name"}},{"kind":"Field","name":{"kind":"Name","value":"item_characteristics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"}},{"kind":"Field","name":{"kind":"Name","value":"payment_status"}},{"kind":"Field","name":{"kind":"Name","value":"order_date"}},{"kind":"Field","name":{"kind":"Name","value":"hub_ids"}}]}}]}}]} as unknown as DocumentNode<TrackingDataQuery, TrackingDataQueryVariables>;
export const FlightInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FlightInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FlightInfoRequestParams"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightNumber"}}]}}]}}]}}]} as unknown as DocumentNode<FlightInfoQuery, FlightInfoQueryVariables>;
export const FlightsByHubIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FlightsByHubIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FlightsByHubIdsRequestParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightsByHubIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalDepartureTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"originalArrivalTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"flightDesignators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"airlineCode"}},{"kind":"Field","name":{"kind":"Name","value":"flightNumber"}},{"kind":"Field","name":{"kind":"Name","value":"airlineName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"originHubDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iataCode"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}}]} as unknown as DocumentNode<FlightsByHubIdsQuery, FlightsByHubIdsQueryVariables>;
export const TranslationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Translations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"app"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"app"},"value":{"kind":"Variable","name":{"kind":"Name","value":"app"}}},{"kind":"Argument","name":{"kind":"Name","value":"lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"languageCodes"}}]}}]}}]} as unknown as DocumentNode<TranslationsQuery, TranslationsQueryVariables>;